import classNames from 'classnames';
import { _ } from '/@/locale';
import styles from './styles.module.css';

export const Cover = ({ type, brand, className = '' }) => {
    return (
        <div className={classNames(styles.root, styles[`theme-${brand.theme}-${type}`], className)}>
            <div className={styles.content}>
                {_('Ficha técnica de producto')}
                <div className={classNames(styles.logo, styles[brand.logoCodename])} />
            </div>
            <div className={styles.bayer} />
        </div>
    );
};
